import {jsonMember, jsonObject} from 'typedjson';
import {LoraMessageType} from '@/model/lora/LoraPacket/LoraMessageType';
import {LoraPacketRxInfo} from '@/model/lora/LoraPacket/LoraPacketRxInfo';
import {LoraPacketType} from '@/model/lora/LoraPacket/LoraPacketType';
import {LoraPacket} from '@/model/lora/LoraPacket/LoraPacket';

@jsonObject
export class LoraPacketUplink extends LoraPacket {

  @jsonMember({name: 'rxInfo'})
  public RxInfo!: LoraPacketRxInfo;

  public get Type(): LoraPacketType {
    return LoraPacketType.Uplink;
  }
}
